import { ACTIVITY_FORMS_NUMBERS } from 'pages/create-activity/constants';

export const addAddOnsLanguage = (
  forms,
  newLanguage,
  changeFormFieldValue,
  updateFormErrors,
  setSavedForms,
  savedForms
) => {
  let addOns = [...forms.addOnsForm.values.addOns];
  addOns = addOns.map(item => {
    if (!item[newLanguage]) {
      return {
        ...item,
        [newLanguage]: {
          title: '',
          description: '',
          USD: '0',
          EUR: '0',
          NOK: '0'
        }
      };
    }
    return item;
  });
  changeFormFieldValue('addOnsForm', 'addOns', addOns);
  if (forms['addOnsForm'].values.addOns.length) {
    updateFormErrors('addOnsForm', {
      init: 'Error'
    });
    setSavedForms({
      ...savedForms,
      addOnsForm: {
        addOns: addOns
      }
    });
  }
};

export const deleteAddOnsLanguage = (
  forms,
  deletedLanguage,
  changeFormFieldValue,
  activeTab,
  setActiveTab,
  setSavedForms,
  savedForms,
  updateFormErrors,
  submitForm
) => {
  let addOns = [...forms.addOnsForm.values.addOns];
  addOns = addOns.map(item => {
    return {
      ...item,
      [deletedLanguage]: null
    };
  });
  changeFormFieldValue('addOnsForm', 'addOns', addOns);
  if (forms['addOnsForm'].values.addOns.length) {
    if (activeTab === ACTIVITY_FORMS_NUMBERS.addOnsForm) {
      setActiveTab(activeTab);
    }
    setSavedForms({
      ...savedForms,
      addOnsForm: {
        addOns: addOns
      }
    });
    submitForm('addOnsForm');
  }
};
